<template>
  <Modal :id="id" title="Contact Your Distributor">
    <div slot="body" class="modal-body">
      <div class="alert alert-info text-center mb-4">
        There no events scheduled at this time. Contact your distributor if you
        are interested in attending an event.
      </div>
      <div v-if="!!course && !!course.show_downloads" class="text-center">
        <a href="#" @click.prevent="$emit('resolve')" class="btn btn-primary"
          >View Course Downloads</a
        >
      </div>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "no-upcoming-events-notice",
      course: null,
    };
  },
  mounted() {
    this.course = this.options.course || null;
  },
};
</script>